import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-main-menu',
  templateUrl: './mobile-main-menu.component.html',
  styleUrls: ['../../../assets/css/light.theme.css']
})
export class MobileMainMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
